export const globalStyles = {
  color: "#FF5A5F",
  backgroundColor: "#F5FAFA",
  font: "Poppins",
  text: {
    xs: "14px",
    sm: "16px",
    md: "20px",
    lg: "22px",
    xl: "36px",
  },
};
